<template>
  <div
    class="rete-boolean-field"
    :class="{ 'rete-boolean-field--compact': compact }"
  >
    <span v-if="showLabel" class="rete-boolean-field__label">{{ title }}</span>
    <div
      v-if="choices"
      class="rete-boolean-field__choices"
      role="group"
      :aria-label="title"
    >
      <button
        v-for="option in choices"
        :key="String(option.value)"
        type="button"
        :aria-pressed="Boolean(value) === option.value"
        @click="update(option.value)"
      >
        {{ option.text }}
      </button>
    </div>
    <button
      v-else
      class="rete-boolean-field__switch"
      type="button"
      role="switch"
      :aria-label="title"
      :aria-checked="Boolean(value)"
      @click="update(!value)"
    >
      <span class="rete-boolean-field__state">{{
        value ? "Ativado" : "Desativado"
      }}</span>
      <span class="rete-boolean-field__track" aria-hidden="true"
        ><span></span
      ></span>
    </button>
  </div>
</template>

<script>
const titles = {
  usar_url_dinamico: "URL dinâmica",
  usar_meta_template: "Template do WhatsApp",
  cec_avancado: "Modo da condição",
  cfe_mensagem: "Formato dos dados",
  tratamento: "Tratamento dos marcadores",
  limpar_variaveis: "Variáveis do usuário",
  criar_novo_lead: "Ao inserir lead",
  redirecionar_caso_erro: "Em caso de erro"
};
const choices = {
  cec_avancado: ["Padrão", "Avançado"],
  cfe_mensagem: ["Lista", "Objeto"],
  tratamento: ["Adicionar", "Substituir"],
  limpar_variaveis: ["Manter", "Limpar"],
  criar_novo_lead: ["Atualizar ou criar", "Sempre criar"],
  redirecionar_caso_erro: ["Não redirecionar", "Redirecionar"]
};

export default {
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    field: { type: Object, required: true },
    label: { type: String, default: "" },
    showLabel: { type: Boolean, default: true },
    compact: { type: Boolean, default: false }
  },
  computed: {
    title() {
      return (
        this.label || titles[this.field.bindText] || this.field.label || "Opção"
      );
    },
    choices() {
      return (
        choices[this.field.bindText]?.map((text, index) => ({
          text,
          value: index === 1
        })) || null
      );
    }
  },
  methods: {
    update(value) {
      if (this.value === value) return;
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.rete-boolean-field {
  align-items: center;
  background: #faf9fc;
  border: 1px solid #e9e3f0;
  border-radius: 9px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  padding: 11px 12px;
  text-transform: none !important;
  width: 100%;
  .rete-boolean-field__label {
    color: #51485f;
    flex: 1 1 120px;
    font-size: calc(12px * var(--rete-card-text-scale, 1));
    font-weight: 600;
    line-height: 1.5;
  }
  button {
    cursor: pointer;
    font: inherit;
    text-transform: none;
    &:focus-visible {
      outline: 2px solid #9974c5;
      outline-offset: 2px;
    }
  }
  .rete-boolean-field__switch {
    align-items: center;
    background: none;
    border: 0;
    border-radius: 5px;
    display: inline-flex;
    gap: 8px;
    padding: 3px 0;
  }
  .rete-boolean-field__state {
    color: #8b8197;
    font-size: calc(10px * var(--rete-card-text-scale, 1));
    font-weight: 500;
  }
  .rete-boolean-field__track {
    background: #d5cfdf;
    border-radius: 20px;
    display: block;
    flex: 0 0 32px;
    height: 19px;
    padding: 3px;
    width: 32px;
    span {
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 1px 3px #0002;
      display: block;
      height: 13px;
      transition: transform 0.15s;
      width: 13px;
    }
  }
  [aria-checked="true"] {
    .rete-boolean-field__state {
      color: #7047a4;
    }
    .rete-boolean-field__track {
      background: #8055ad;
      span {
        transform: translateX(13px);
      }
    }
  }
  .rete-boolean-field__choices {
    background: #eeebf3;
    border-radius: 7px;
    display: flex;
    gap: 3px;
    padding: 3px;
    button {
      background: transparent;
      border: 1px solid transparent;
      border-radius: 5px;
      color: #81758e;
      font-size: calc(10px * var(--rete-card-text-scale, 1));
      padding: 6px 8px;
      &[aria-pressed="true"] {
        background: #fff;
        border-color: #e2d8ee;
        box-shadow: 0 1px 3px #3924510d;
        color: #7047a4;
        font-weight: 600;
      }
    }
  }
  &.rete-boolean-field--compact {
    border: 0;
    gap: 6px;
    padding: 4px 0;
    .rete-boolean-field__label {
      font-size: calc(10px * var(--rete-card-text-scale, 1));
    }
    .rete-boolean-field__choices button {
      padding: 4px 6px;
    }
  }
}
</style>
